import { render } from "./FundingTraining.vue?vue&type=template&id=6d70771c&scoped=true"
import script from "./FundingTraining.vue?vue&type=script&lang=js"
export * from "./FundingTraining.vue?vue&type=script&lang=js"

import "./FundingTraining.vue?vue&type=style&index=0&id=6d70771c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d70771c"]])

export default __exports__